var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 33.4742V25.0742H12.2V33.4742C12.2 34.8667 13.3075 35.9742 14.7 35.9742H33.5C34.8925 35.9742 36 34.8667 36 33.4742V25.0742H38.2V33.4742C38.2 36.0817 36.1075 38.1742 33.5 38.1742H14.7C12.0925 38.1742 10 36.0817 10 33.4742Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2001 11.7754V28.7754H23.0001V11.7754H25.2001Z",
    fill: "#121619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4795 10.7411C23.3698 9.68751 24.9149 9.83439 25.7778 10.6973C25.7841 10.7036 25.7904 10.71 25.7966 10.7165L31.7966 17.0165L30.2034 18.5337L24.2166 12.2475C24.1836 12.2168 24.1497 12.2046 24.1263 12.2012C24.1146 12.2145 24.1026 12.2275 24.0903 12.2403L17.9903 18.5403L16.4097 17.0099L22.4795 10.7411Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadLight);
export default __webpack_public_path__ + "static/media/icon_upload_light.99bd7817.svg";
export { ForwardRef as ReactComponent };